import { render, staticRenderFns } from "./ImgFallback.vue?vue&type=template&id=38cf7cba&"
import script from "./ImgFallback.vue?vue&type=script&lang=js&"
export * from "./ImgFallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38cf7cba')) {
      api.createRecord('38cf7cba', component.options)
    } else {
      api.reload('38cf7cba', component.options)
    }
    module.hot.accept("./ImgFallback.vue?vue&type=template&id=38cf7cba&", function () {
      api.rerender('38cf7cba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-26umCrTn3XRce/JS/comp/ImgFallback.vue"
export default component.exports